import React, { useState } from "react";
import {
  Box,
  Button,
  MenuItem,
  Select,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Checkbox,
  ListItemText,
  Dialog, DialogTitle, DialogContent, DialogActions,
  Stack
} from "@mui/material";
import FormLabel from "@mui/material/FormLabel";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { LocalizationProvider, DatePicker, TimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import AxiosInstance from "../../services/AxiosInstance";
import { REPORT_SCHEDULE_URL, REPORT_SCHEDULE_REPORT_URL, REPORT_SCHEDULE_UPDATE_URL } from "../../Constants/Constants";
import { useAlert } from "./../alerts//AlertContext";
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import dayjs from 'dayjs';
import { parse, format } from "date-fns";
import Grid from "@mui/material/Grid2";

const daysOfWeek = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"];
const daysOfWeekMap = {
  SUNDAY: 0,
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6
};

const monthDates = Array.from({ length: 31 }, (_, i) => (i + 1).toString());

function generateCron({ frequency, time, weekDays, monthDays, dayOfMonth, monthOfYear }) {
  if (!time) return "* * * * * *";

  const minute = time.getUTCMinutes();
  const hour = time.getUTCHours();

  if (frequency === "DAILY") {
    return `0 ${minute} ${hour} * * *`;
  }

  if (frequency === "WEEKLY") {
    //const days = weekDays && weekDays.length > 0 ? weekDays.join(",") : "*";
    //return `0 ${minute} ${hour} * * ${days}`;

    const days = weekDays.length > 0
      ? weekDays.map(d => daysOfWeekMap[d.toUpperCase()]).join(",")
      : "*";
    return `0 ${minute} ${hour} * * ${days}`;

  }

  if (frequency === "MONTHLY") {
    const days = monthDays && monthDays.length > 0 ? monthDays.join(",") : "1";
    return `0 ${minute} ${hour} ${days} * *`;
  }

  if (frequency === "QUARTERLY") {
    return `0 ${minute} ${hour} ${dayOfMonth} 1,4,7,10 ?`;
  }

  if (frequency === "YEARLY") {
    return `0 ${minute} ${hour} ${dayOfMonth} ${monthOfYear} ?`;
  }

  return "* * * * * *";
}


export default function ReportScheduleDialog({ editReportId, selectedReport }) {

  const [frequency, setFrequency] = useState("DAILY");
  const [id, setId] = useState("");
  const [reportId, setReportId] = useState();
  const [cron, setCron] = useState();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [email, setEmail] = useState("");
  const [weekDays, setWeekDays] = useState([]);
  const [monthDays, setMonthDays] = useState([]);
  const [time, setTime] = useState(new Date());
  const [active, setActive] = useState(true);
  const [open, setOpen] = useState(false);
  const [dayOfMonth, setDayOfMonth] = useState(1);
  const [monthOfYear, setMonthOfYear] = useState(1);



  const showAlert = useAlert();

  const theme = createTheme({
    // ...globaltheme,
    components: {
      MuiSelect: {
        defaultProps: {
          sx: {
            borderRadius: "8px",
            // Prevent italic placeholder/label
            "& em": {
              fontStyle: "normal",
            },
          },
        },
      },
      MuiButton: {
        defaultProps: {
          sx: {
            marginTop: 2,
            marginBottom: 2,
            display: "block",
          },
        },
      },
    },
  });


  const handleSubmit = async () => {
    const payload = {
      frequency,
      startDate: startDate.toISOString().split("T")[0],
      endDate: endDate.toISOString().split("T")[0],
      email,
      weekDays,
      monthDays,
      //time: time.toTimeString().slice(0,5) // "HH:mm"
      time: time.toISOString().slice(11, 16)
    };

    // await fetch("/api/reports/schedule", {
    //   method: "POST",
    //   headers: { "Content-Type": "application/json" },
    //   body: JSON.stringify(payload),
    // });

    const cronExpression = generateCron({
      frequency,
      time,
      weekDays,
      monthDays,
      dayOfMonth,
      monthOfYear
    });

    var reportScheduleObj = {};
    reportScheduleObj.cron = cronExpression;
    //reportScheduleObj.startDate = startDate.toISOString().split("T")[0];
    //reportScheduleObj.endDate = endDate.toISOString().split("T")[0];

    reportScheduleObj.startDate = startDate;//.toISOString().split("T")[0];
    reportScheduleObj.endDate = endDate;//.toISOString().split("T")[0];
    reportScheduleObj.active = active;
    reportScheduleObj.report = { id: editReportId };
    reportScheduleObj.frequency = frequency;
    reportScheduleObj.runTime = time.toISOString().slice(11, 16);
    reportScheduleObj.toEmail = email;

    if (frequency === "WEEKLY") {
      reportScheduleObj.weekly = weekDays.join(", ");
    }
    if (frequency === "MONTHLY") {
      reportScheduleObj.monthly = monthDays.join(", ");
    }
    if (frequency === "YEARLY") {
      reportScheduleObj.dayOfMonth = dayOfMonth;
      reportScheduleObj.monthOfYear = monthOfYear;
    }


    AxiosInstance.post((id === "") ? REPORT_SCHEDULE_URL : REPORT_SCHEDULE_UPDATE_URL, JSON.stringify(reportScheduleObj))
      .then((response) => {
        if (id === "")
          showAlert("Report scheduled successfully!", "success");
        else
          showAlert("Report schedule updated successfully!", "success");
      })
      .catch((error) => {
        if (id === "")
          showAlert("Report scheduling is failed!", "error");
        else
          showAlert("Report schedue udpateding is failed!", "error");

        console.error(error);
      });

    //alert(cronExpression);
    //alert("Report schedule saved!" + JSON.stringify(payload));
  };

  const getReportSchedule = async () => {
    await AxiosInstance.get(REPORT_SCHEDULE_REPORT_URL + editReportId).then((response) => {
      var reportData = response.data;
      if (reportData !== null) {
        setId(reportData.id);
        setReportId(reportData.reportId);
        setCron(reportData.cron);
        setStartDate(new Date(reportData.startDate));
        setEndDate(new Date(reportData.endDate));
        setActive(reportData.active);
        setFrequency(reportData.frequency);
        if (reportData.frequency === "WEEKLY") {
          setWeekDays(reportData.weekly.split(",").map(item => item.trim()));
        }
        if (reportData.frequency === "MONTHLY") {
          setMonthDays(reportData.monthly.split(",").map(item => item.trim()));
        }
        if (frequency === "YEARLY") {
          setDayOfMonth(reportData.dayOfMonth);
          setMonthOfYear(reportData.monthOfYear);
        }

        const newTimeString = reportData.runTime; // 24-hour format
        const [hours, minutes] = newTimeString.split(":");
        const runTimeDate = new Date();
        runTimeDate.setUTCHours(hours);
        runTimeDate.setUTCMinutes(minutes);
        runTimeDate.setUTCSeconds(0);

        setTime(runTimeDate);
        setEmail(reportData.toEmail);

      }
      //setReportData(reportData);

      setOpen(true);
    }).catch((err) => {
      console.error(err)
      if (err.response.status === 404) {
        setOpen(true);
      }
    });
  };

  const handleClickOpen = () => {
    getReportSchedule();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };


  const handleWeeklyChange = (day) => {
    setWeekDays((prev) =>
      prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
    );
  };

  const handleMonthlyChange = (day) => {
    setMonthDays((prev) =>
      prev.includes(day)
        ? prev.filter((d) => d !== day) // remove if already selected
        : [...prev, day]                // add if not selected
    );
  };

  const handleStatusChange = (event) => {
    setActive(event.target.value);
  };

  return (
    <ThemeProvider theme={theme}>
      <React.Fragment>

        {/* <Button variant="outlined" size="small" onClick={handleClickOpen} style={{float:"right", margin:"2px"}}>
              Schedule Report
            </Button> */}

        <ScheduleSendIcon
          style={{ cursor: "pointer" }}
          onClick={handleClickOpen}
        />

        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{
            component: 'form',
            onSubmit: (event) => {
              event.preventDefault();
              //saveTicket();                    
              handleClose();
            },
          }}
        >
          <DialogTitle>Schedule Report</DialogTitle>
          <DialogContent>

            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Box sx={{ p: 3, maxWidth: 500, mx: "auto", boxShadow: 3, borderRadius: 2 }}>

                {/* Frequency */}
                <FormControl fullWidth sx={{ mb: 2 }} size="small">
                  <InputLabel id="demo-simple-select-label">Frequency</InputLabel>
                  <Select labelId="demo-simple-select-label" value={frequency}
                    id="demo-select-small"
                    onChange={(e) => setFrequency(e.target.value)}>
                    <MenuItem value="DAILY">Daily</MenuItem>
                    <MenuItem value="WEEKLY">Weekly</MenuItem>
                    <MenuItem value="MONTHLY">Monthly</MenuItem>
                    <MenuItem value="QUARTERLY">QUARTERLY</MenuItem>
                    <MenuItem value="YEARLY">YEARLY</MenuItem>
                  </Select>
                </FormControl>

                {/* Weekly days selection */}
                {frequency === "WEEKLY" && (
                  <FormControl fullWidth sx={{ mb: 2 }} size="small">
                    <InputLabel>Select Days</InputLabel>
                    <Select
                      multiple
                      value={weekDays}
                      onChange={(e) => setWeekDays(e.target.value)}
                      renderValue={(selected) => selected.join(", ")}
                    >
                      {daysOfWeek.map((day, index) => (
                        <MenuItem key={day} value={day}>
                          <Checkbox checked={weekDays.indexOf(day) > -1} />
                          <ListItemText primary={day} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}

                {/* Monthly date selection */}
                {frequency === "MONTHLY" && (
                  <FormControl fullWidth sx={{ mb: 2 }} size="small">
                    <InputLabel>Select Dates</InputLabel>
                    <Select
                      multiple
                      value={monthDays}
                      onChange={(e) => setMonthDays(e.target.value)}
                      renderValue={(selected) => selected.join(", ")}
                    >
                      {monthDates.map((date) => (
                        <MenuItem key={date} value={date}>
                          <Checkbox checked={monthDays.indexOf(date) > -1} />
                          <ListItemText primary={date} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}

                {frequency === "YEARLY" && (

                  <Grid container spacing={2} >
                    <Grid item xs={6}>
                      <TextField size="small" value={dayOfMonth} fullWidth sx={{ mb: 2 }} type="number" label="Day" value={dayOfMonth} onChange={e => setDayOfMonth(e.target.value)} inputProps={{ min: 1, max: 31 }} />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField size="small" value={monthOfYear} fullWidth sx={{ mb: 2 }} type="number" label="Month (1-12)" value={monthOfYear} onChange={e => setMonthOfYear(e.target.value)} inputProps={{ min: 1, max: 12 }} />
                    </Grid>
                  </Grid>

                )}
                <Stack direction="row" spacing={2} sx={{ mb: 2, size: "small" }}>
                  {/* Start Date */}
                  <DatePicker
                    sx={{ mb: 2, size: "small" }}
                    label="Start Date"
                    size="small"
                    value={startDate}
                    onChange={(newDate) => setStartDate(newDate)}
                    renderInput={(params) => <TextField {...params} value={startDate ? format(startDate, "MM/DD/YYYY") : ""} sx={{ mb: 2 }} size="small" fullWidth />}
                  />

                  {/* End Date */}
                  <DatePicker
                    sx={{ mb: 2 }}
                    size="small"
                    label="End Date"
                    value={endDate}
                    onChange={(newDate) => setEndDate(newDate)}
                    renderInput={(params) => <TextField {...params} value={endDate ? format(endDate, "MM/DD/YYYY") : ""} sx={{ mb: 2 }} fullWidth />}
                  />
                </Stack>

                {/* Time Picker */}
                <Stack direction="row" spacing={2} sx={{ mb: 2, size: "small" }}>
                  <TimePicker
                    label="Run Time"
                    sx={{ mb: 2 }}
                    value={time}
                    onChange={(newTime) => setTime(newTime)}
                    renderInput={(params) => <TextField {...params} value={time} sx={{ mb: 2 }} fullWidth size="small" />}
                  />

                  <FormControl>
                    <FormLabel id="demo-row-radio-buttons-group-label">
                      Active
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={active}
                      onChange={handleStatusChange}
                    >
                      <FormControlLabel
                        value={true}
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value={false}
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                </Stack>
                {/* Email */}
                <TextField
                  label="Email"
                  fullWidth
                  size="small"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  sx={{ mb: 2 }}
                  placeholder="recipient@example.com"
                />

                <Button size="small" variant="contained" color="primary" onClick={handleSubmit} fullWidth>
                  Save Schedule
                </Button>
              </Box>
            </LocalizationProvider>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Close</Button>
            {/* <Button type="submit">Add </Button> */}
          </DialogActions>
        </Dialog>
      </React.Fragment>
    </ThemeProvider>
  );
}
